import React, { useState } from "react";
// import _ from "lodash";
import { amountFormat } from "../../utils";
import { useHistory } from "react-router-dom";
import BaseCurrency from "../Common/BaseCurrency";

const PendingReportsCard = ({ dashboard }) => {
  const [isPending, setIsPending] = useState(true);
  const history = useHistory();
  return (
    <div className="pending-card">
      <h2 className="flex-between">
        <span>Pending Reports</span>
        <span
          className="active-text cursor"
          onClick={() => {
            history.push("/reports", {
              status: isPending ? "pending_approval" : "pending_reimbursement",
            });
          }}
        >
          View all
        </span>
      </h2>
      <div className="tabs">
        <div
          className={`${isPending ? "active" : ""} cursor`}
          onClick={() => setIsPending(true)}
        >
          For Approval <br /> ({dashboard?.pending_counts?.report_pending_approval}{" "}
          reports)
        </div>
        <div
          className={`${!isPending ? "active" : ""} cursor`}
          onClick={() => setIsPending(false)}
        >
          For Reimbursement <br /> ({dashboard?.pending_counts?.report_pending_reimbursement} reports)
        </div>
      </div>
      <div className="mt1">
        <div className="titles mb1">
          <span>User</span>
          <span>Amount</span>
        </div>
        {dashboard?.[
          isPending ? "report_pending_approval" : "report_pending_reimbursement"
        ]?.length > 0 ? dashboard?.[
          isPending ? "report_pending_approval" : "report_pending_reimbursement"
        ]?.map((ele) => (
          <div className="values">
            <aside>
              {/* <b> 14 May 2022</b> <br /> */}
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  // cursor:"pointer"
                }}
                onClick={() => {
                  // history.push("/report-details/" + ele.report_id)
                }}
              >
                <span className="circle">{ele.user_name?.[0]}</span>
                {ele.user_name}
              </span>
            </aside>
            <aside><BaseCurrency /> {amountFormat(ele.amount)}</aside>
          </div>
        )) : <div className="no-data">
          <span>No Pending reports</span>
        </div>}
      </div>
    </div>
  );
};

export default PendingReportsCard;
